// extracted by mini-css-extract-plugin
export default {"FixedMenuButton":"FixedMenuButton_FixedMenuButton__XUJJy"};